export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-calender-row-1.0.0',
    name: 'JDSDatepickerCalendarRow'
  },
  hierarchy: {
    container: ['jds_datepicker_calendar_button']
  },
  base: {
    container: {
      'flex-direction': '{d_0}',
      'justify-content': '{d_1}',
      'align-items': '{d_2}',
      width: '{d_3}'
    },
    jds_datepicker_calendar_button: {
      flex: 1
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      container: {
        value: {
          type: 'list',
          name: 'row',
          object: {
            value: 'string',
            state: 'JDSDatepickerCalendarButton.state',
            disabled: 'boolean'
          }
        }
      },
      jds_datepicker_calendar_button: {
        value: {
          type: 'string',
          name: 'row.value'
        },
        state: {
          type: 'JDSDatepickerCalendarButton.state',
          name: 'row.state'
        },
        disabled: {
          type: 'string',
          name: 'row.disabled'
        }
      }
    },
    events: {
      jds_datepicker_calendar_button: {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'radiogroup'
          }
        }
      },
      jds_datepicker_calendar_button: {
        properties: {
          ariaLabel: 'dateAriaLabel'
        }
      }
    }
  }
};
